import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import { ZdarGameHint } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import parse from 'html-react-parser';

type Props = {
    hint: ZdarGameHint;
};

export default function ZdarKidsHint({ hint }: Props) {
    return (
        <div className="zdar-hint">
            {hint.text && <div className="zdar-hint-text">{hint.text}</div>}
            {hint.html && <div className="zdar-hint-text">{parse(hint.html)}</div>}
            {hint.image && (
                <div className="zdar-hint-image">
                    <ImageWrapper src={hint.image} alt="hint" allowLightbox={false} />
                </div>
            )}
        </div>
    );
}
